export const grayLog = () => {
    if (
        process.client ||
        !process.env.GRAYLOG_HOST ||
        !process.env.GRAYLOG_PORT
    ) {
        return;
    }
    const log = async (
        message: string,
        fullMessage: string,
        additionalFields?: Record<string, any>
    ) => {
        try {
            const graylog2 = await import('graylog2');
            // eslint-disable-next-line new-cap
            const logger = new graylog2.graylog({
                servers: [
                    {
                        host: process.env.GRAYLOG_HOST!,
                        port: Number(process.env.GRAYLOG_PORT!),
                    },
                ],
                hostname: process.env.GRAYLOG_NAME || 'WebProduction',
            });
            logger.log(
                message,
                fullMessage,
                additionalFields,
                new Date() as unknown as number
            );
        } catch {}
    };
    return { log };
};
